module.exports = __webpack_public_path__ + "img/icon4.70fb6fd7.png";